import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import endPoint from "../EndPoint/endpoint";

// Async thunk for reseller registration
export const ResellerRegisterApi = createAsyncThunk(
  "resellerRegisterData/resellerRegister",
  async (data, thunkAPI) => {
    console.log("Registering reseller with data:", data);
    try {
      const response = await axios.post(endPoint.ResellerRegister, data);
      return response?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  },
);

const ResellerRegisterSlice = createSlice({
  name: "ResellerRegisterData",
  initialState: {
    ResellerRegisterData: [],
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(ResellerRegisterApi.fulfilled, (state, action) => {
        state.ResellerRegisterData = action.payload;
      })
      .addCase(ResellerRegisterApi.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export default ResellerRegisterSlice.reducer;
